<template lang="pug">
div(v-if="userflow")
  v-btn(
    width="290",
    color="primary",
    @click="openAdditionalQuiz",
    :disabled="disabled"
  ) answer additional questions
</template>

<script>
export default {
  name: "additional-questions",

  props: {
    group: {
      type: String,
      required: true,
      validator: (v) => ["company", "case"].includes(v),
    },

    isPaid: {
      type: Boolean,
      default: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    dialog: false,
    aliases: {
      company: ["company_profile_paid"],
      case: [
        "case_paid",
        "case_paid_officer",
        "case_paid_key",
        "case_paid_lvl1",
        "case_paid_cos",
      ],
    },
  }),

  methods: {
    openAdditionalQuiz() {
      if (this.isPaid)
        this.$store.dispatch("flows/openQuiz", {
          alias: this.userflow.flow.alias,
        });
      else this.$store.commit("setPayDialog", true);
    },
  },

  computed: {
    flows() {
      return this.$store.state.flows.list;
    },

    userflow() {
      let fl;
      let isFirst = true;
      this.aliases[this.group].forEach((el) => {
        let fls = this.flows.filter((f) => f.flow.alias === el);
        if (fls.length === 1 && fls[0].status !== "passed" && isFirst) {
          fl = fls[0];
          isFirst = false;
        }
      });
      return fl ?? null;
    },
  },
};
</script>